import { useI18n } from '../i18n';

interface Props {
  remainingMs: number | null;
  /** 0..1 */
  progress: number;
  urgentBelowMs?: number;
}

/**
 * 對著伺服器的 `deadline_at` 倒數（C02 §5）。
 * a11y：環是純裝飾（aria-hidden），真正的資訊放在旁邊的文字，並用 aria-live="polite"
 * 讓螢幕閱讀器在最後幾秒得到提醒 —— 但不是每 200ms 都念一次（那會很吵）。
 */
export function Countdown({ remainingMs, progress, urgentBelowMs = 3000 }: Props) {
  const { t } = useI18n();
  if (remainingMs === null) return null;

  const seconds = Math.ceil(remainingMs / 1000);
  const urgent = remainingMs <= urgentBelowMs;
  const r = 22;
  const circumference = 2 * Math.PI * r;

  return (
    <div className={`countdown${urgent ? ' countdown--urgent' : ''}`}>
      <svg className="countdown__ring" width="52" height="52" viewBox="0 0 52 52" aria-hidden="true">
        <circle cx="26" cy="26" r={r} fill="none" stroke="var(--c-surface-3)" strokeWidth="5" />
        <circle
          cx="26"
          cy="26"
          r={r}
          fill="none"
          stroke={urgent ? 'var(--c-lose)' : 'var(--c-accent)'}
          strokeWidth="5"
          strokeLinecap="round"
          strokeDasharray={circumference}
          strokeDashoffset={circumference * (1 - progress)}
          transform="rotate(-90 26 26)"
        />
      </svg>
      <span className="countdown__label" aria-live={urgent ? 'assertive' : 'off'}>
        {t('match.timeLeft', { seconds })}
      </span>
    </div>
  );
}
